module.exports = __webpack_public_path__ + "img/preview_pdf16x9.ca77a8a8.png";